import React from "react";
import { useTheme } from "../../context/ThemeContext";

// Fela R.I.O wordmark — white-text artwork on dark surfaces, black-text artwork on light surfaces.
export const BRAND = { name: "Fela R.I.O", tagline: "Real-time Intelligence Orchestrator", dark: "/brand/fela-rio-dark.webp", light: "/brand/fela-rio-light.webp" };

export function BrandLogo({ variant, className = "h-10", testid = "brand-logo" }) {
  const { theme } = useTheme();
  const v = variant ?? theme;
  return <img data-testid={testid} src={v === "light" ? BRAND.light : BRAND.dark} alt={`${BRAND.name} — ${BRAND.tagline}`} className={`${className} w-auto object-contain select-none`} draggable={false} />;
}
